import { render, staticRenderFns } from "./ControlFishTank.vue?vue&type=template&id=4455f5bc&scoped=true&"
import script from "./ControlFishTank.vue?vue&type=script&lang=js&"
export * from "./ControlFishTank.vue?vue&type=script&lang=js&"
import style0 from "./ControlFishTank.vue?vue&type=style&index=0&id=4455f5bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455f5bc",
  null
  
)

export default component.exports